import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Box } from "@mui/material";
import { accessId } from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { TkRouteContext } from "../../context/tkRouteContext";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkQRCode from "../../components/atoms/TkQRCode";
import { httpAPI_RET012 } from "./api/request";
import { fakeTableList } from "./parts";
import "./_style.scss";
import _ from "lodash";

/**
 * SCRC060129 退職者識別コード
 * @return SCRC060129 退職者識別コード
 */
const SCRC060129 = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const { state: stateRouter, setState: setStateRouter } =
    useContext(TkRouteContext);
  // ユーザタイプが機構
  const isUserTypeKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  //ユーザタイプが代行者
  const isUserTypeDaikosya =
    state.authInfo?.userType === authorityUserType.userTypeNumber.DAIKOSHA;
  // 共済契約者番号
  const contractorNo = isUserTypeKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  // 共済契約者名
  const contractorName = isUserTypeKiko
    ? businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName
    : state.authInfo?.contractorNo + ":" + state.authInfo?.name;

  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [showButton, setShowButton] = useState(true);

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpAPI_RET012({
        contractorNo: contractorNo,
        staffNo: location.state?.staffNo || businessState.job_32?.staffNo,
        applyId: location.state?.applyId || businessState.job_32?.applyId,
        businessType: "JOB-32",
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;

        // 契約者（法人）名
        let contractorAndNumber = resArr.find(
          (item) => item.keyword === "contractorAndNumber"
        )!;
        contractorAndNumber.showLine = isUserTypeKiko;
        contractorAndNumber.contractorNumber = contractorName;

        // 共済契約者名
        resArr.find((item) => item.keyword === "contractorName")!.text =
          contractorName;

        // 退職者識別コード
        resArr.find((item) => item.keyword === "transferCd")!.text =
          res.transferCd;

        // 職員氏名
        resArr.find((item) => item.keyword === "staffNameKanji")!.text =
          res.staffNameKanji;

        // 職員氏名（ｶﾅ）
        resArr.find((item) => item.keyword === "staffNameKana")!.text =
          res.staffNameKana;

        // QRコード
        resArr.find((item) => item.keyword === "qrCode")!.node = (
          <Box className="missingFile">
            <TkQRCode
              QRLink={res.url + "?" + accessId + "=" + res.corpAccessUrlId}
            />
          </Box>
        );

        // URL
        resArr.find((item) => item.keyword === "URL")!.text =
          res.url + "?" + accessId + "=" + res.corpAccessUrlId;

        if (isUserTypeDaikosya) {
          setShowButton(false);
        }

        setStateTableList([...resArr]);

        setState({ ...state, errorMsgId: "" });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    const routerList = stateRouter.routerList || [];
    const updateRouterList = routerList?.filter((item) =>
      [
        "/SCRC020001",
        "/SCRW110001",
        "/SCRW110005",
        "/SCRD310001",
        "/SCRC060129",
      ].includes(item.href ?? "")
    );
    if (
      routerList[routerList.length - 1]?.href !== "/SCRC060129" ||
      _.isEqual(updateRouterList, routerList)
    )
      return;

    if (routerList[routerList.length - 2]?.href === "/SCRC060031") {
      setShowButton(false);
    } else {
      setStateRouter({
        routerList: updateRouterList as any,
      });
    }

    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateRouter]);

  const handleSubmit = async (index: any) => {
    switch (index) {
      case 0: //印刷
        window.print();
        break;

      case 1: // 完了
        if (isUserTypeKiko) {
          navigate("/SCRW070008");
        } else {
          navigate("/SCRC060031");
        }
        break;

      case 2: // 退職予定者一覧
        const wantToSetInRouterList = stateRouter.routerList?.filter(
          (item) => item.href !== "/SCRC060129"
        );
        wantToSetInRouterList?.push({
          title: "退職予定者一覧",
          href: "/SCRC060118",
        });
        navigate("/SCRC060118", { state: { wantToSetInRouterList } });
        break;
    }
  };

  return (
    <Box data-testid="SCRC060129PageForTest">
      <TkFakeTable
        list={stateTableList}
        ruleSchema={{}}
        submitButtonGroup={[
          {
            submitButtonText: "印刷",
          },
          {
            submitButtonText: "完了",
          },
          {
            submitButtonText: "退職予定者一覧",
            showButton: showButton,
          },
        ]}
        onCheckAndSubmit={(_data, index) => handleSubmit(index)}
      />
    </Box>
  );
};

export default SCRC060129;
